import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: [],
};

export const UserProfileSlice = createSlice({
    name: 'userProfile',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.userDetails = action.payload;
        },
    }
})

export const { setUser } = UserProfileSlice.actions;

export default UserProfileSlice.reducer;